var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.overriddenTemplate)?_c('TixTemplate',{staticClass:"overridden svg-icon",attrs:{"template":_vm.overriddenTemplate,"wrapper":false}}):_c(_vm.name,{tag:"component",staticClass:"default svg-icon",attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }